import { Observable } from 'rxjs';

import { AppService } from 'app/services/app.service';
import {
  ChaveVirtualResponse,
  ChaveVirtualUpdateRequest
} from 'app/pages/full-pages/chave-virtual-acesso/chave-virtual-acesso.models';

export abstract class AbChaveVirtualAcesso extends AppService {
  abstract buscar(): Observable<ChaveVirtualResponse>;
  abstract atualizar(
    request: ChaveVirtualUpdateRequest
  ): Observable<ChaveVirtualResponse>;
}
